import { v4 as uuidv4 } from 'uuid';
import * as imageStorage from '@/store/image_storage';
import { deepClone, isBlank } from "@/common/utils";

export const image = {
  state: {
    images: { 
        /*
        uuid: { // of image
          uuid: null,
          filename: null,
          caption:
          onwerUUID: null,
          ownerType: null,
          siteUUID: null
        }
        */
    },
    ownerships: {
      /*
        uuid: [
          "uuid"
        ]
      */
    }
  },
  mutations: {
    insertImage(state, newImage) {
      state.images[newImage.uuid] = newImage;
    },

    addImageToOwner(state, args) {
      if (state.ownerships[args.owner_uuid]) {
        if (state.ownerships[args.owner_uuid].indexOf(args.image_uuid) == -1) {
          // if the image_uuid is not already in state.ownership, add it
          state.ownerships[args.owner_uuid].push(args.image_uuid);
        }
      } else {
        state.ownerships[args.owner_uuid] = [args.image_uuid];
      }
    },

    updateImage(state, updatedImage) {
      state.images[updatedImage.uuid] = updatedImage
    },

    removeImage(state, image_uuid) {
      delete state.images[image_uuid]
    },

    removeImageFromOwner(state, { owner_uuid, image_uuid }) {
      console.log("Inside remvoeImageFromOwner, owner_uuid ==> ", owner_uuid);
      console.log("Inside remvoeImageFromOwner, image_uuid ==> ", image_uuid);
      state.ownerships[owner_uuid] = state.ownerships[owner_uuid].filter(function(aUUID) {
        return aUUID !== image_uuid;
      });
      if (isBlank(state.ownerships[owner_uuid])) {
        delete state.ownerships[owner_uuid]
      }      
    },

    removeAllImages(state) {
      state.images = {};
      state.ownerships = {};
    }
  },
  actions: {
    addImage({ commit, dispatch }, newImage) {
      let annotations;
      if (newImage.annotations) {
        annotations = newImage.annotations;
        delete newImage.annotations;
      }

      if (!newImage.uuid) {
        const newUUID = uuidv4();
        newImage.uuid = newUUID;
      }
      if (!newImage.created_at) {
        newImage.created_at = new Date().toISOString();
      }

      commit("insertImage", newImage);

      if (newImage.owner_uuid) {
        commit("addImageToOwner", {owner_uuid: newImage.owner_uuid, image_uuid: newImage.uuid});
      }

      // add the annotations
      if (annotations) {
        annotations.forEach(function(annotation) {
          dispatch('submitAnnotation', annotation);
        })
      }
    },

    // updating an existing image, probably from AIMS
    updateImage({ commit, dispatch }, newImage) {
      let annotations;

      if (newImage.annotations) {
        annotations = newImage.annotations;
        delete newImage.annotations;
      }

      commit("updateImage", newImage);

      if (newImage.owner_uuid) {
        commit("addImageToOwner", {owner_uuid: newImage.owner_uuid, image_uuid: newImage.uuid});
      }

      // add the annotations
      if (annotations) {
        annotations.forEach(function(annotation) {
          dispatch('submitAnnotation', annotation);
        })
      }
    },    

    updateImageCaption({ commit, getters }, payload) {
      let existing = getters.getImage(payload.uuid);
      existing.caption = payload.caption;
      existing.updated_at = new Date().toISOString();
      console.log("Inside image.module.js, updateImageCaption, existing ==> ", existing);
      commit("updateImage", existing);
    },

    touchImage({ commit, getters }, image_uuid) {
      const image = getters.getImage(image_uuid);
      image.updated_at = new Date().toISOString();
      commit("updateImage", image);
    },

    timestampImageSync({ commit, getters }, image_uuid) {
      const image = getters.getImage(image_uuid);
      image.sync_on = new Date().toISOString();
      commit("updateImage", image);
    },

    deleteImage({ commit, dispatch }, image) {
      const image_uuid = image.uuid;
      const owner_uuid = image.owner_uuid;
      imageStorage.deleteImage(image_uuid).then(function() {
        commit("removeImageFromOwner", { owner_uuid, image_uuid })
        commit("removeImage", image_uuid);  
        // delete the annotations
        dispatch('clearImageAnnotations', image_uuid);
      })
    },

    deleteImagesByOwner({ getters, dispatch }, owner_uuid) {
      const all_images = getters.allImagesByOwner(owner_uuid);
      console.log("Inside image.module.js deleteImagesByOwner(), all_images ==> ", all_images)
      all_images.forEach(function(image) {
        dispatch('deleteImage', image);
      })
    },

    clearAllImages({ commit, dispatch }) {
      commit("removeAllImages");
      dispatch('clearAllAnnotations')
    }

  },
  getters: {
    getImage(state) {
      return function(uuid) {
        const image = state.images[uuid];
        return image ? deepClone(image) : null;
      }
    },

    allImages(state) {
      return state.images
    },

    allImageOwnerships(state) {
      return state.ownerships
    },

    allImagesByOwner(state, getters) {
      return function(owner_uuid) {
        const image_uuids = state.ownerships[owner_uuid];
        if (image_uuids) {
          return image_uuids.map(function(uuid) {
            return getters.getImage(uuid);
          });
        } else {
          return [];
        }
      }
    },

    nbImagesByOwner() {
      return function(owner_uuid) {
        return this.allImagesByOwner(owner_uuid).length
      }
    },

    allImagesBySiteUUID(state, getters) {
      return function(siteUUID) {
        return Object.values(state.images).filter(function(image) {
          return (image.site_uuid == siteUUID);
        }).map(function(image) {
          return getters.getImage(image.uuid);
        });
      };
    }

  }
}